import { useSplitEnabled } from '@buffer-mono/features'
import { Loader } from '@buffer-mono/popcorn'
import { Navigate, useLocation } from 'react-router-dom'

import { getPostInsightsHref } from '../components/insightsSectionHref'
import { HabitsPage } from './HabitsPage'
import { INSIGHTS_HABITS_SPLIT } from './habitsSplit'

import type { JSX } from 'react'

export function HabitsRoute(): JSX.Element {
  const location = useLocation()
  const { hasClient, isEnabled, isReady, isTimedout } = useSplitEnabled(
    INSIGHTS_HABITS_SPLIT,
  )

  if (!hasClient) {
    return <Loader />
  }

  if (!isReady && !isTimedout) {
    return <Loader />
  }

  if (isTimedout || !isEnabled) {
    return <Navigate to={getPostInsightsHref(location.search)} replace />
  }

  return <HabitsPage />
}
